/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type CompanyChannelInfoByIdQueryVariables = Exact<{
  companyId: string;
}>;


export type CompanyChannelInfoByIdQuery = { company_by_pk: { id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, photos: Array<{ photo: { path: string, domain: string | null } }> } | null };


export const CompanyChannelInfoByIdDocument = /*#__PURE__*/ gql`
    query CompanyChannelInfoById($companyId: uuid!) {
  company_by_pk(id: $companyId) {
    ...companyFragment
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCompanyChannelInfoByIdQuery__
 *
 * To run a query within a React component, call `useCompanyChannelInfoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyChannelInfoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyChannelInfoByIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyChannelInfoByIdQuery(baseOptions: Apollo.QueryHookOptions<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables> & ({ variables: CompanyChannelInfoByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>(CompanyChannelInfoByIdDocument, options);
      }
export function useCompanyChannelInfoByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>(CompanyChannelInfoByIdDocument, options);
        }
// @ts-ignore
export function useCompanyChannelInfoByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>;
export function useCompanyChannelInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyChannelInfoByIdQuery | undefined, CompanyChannelInfoByIdQueryVariables>;
export function useCompanyChannelInfoByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>(CompanyChannelInfoByIdDocument, options);
        }
export type CompanyChannelInfoByIdQueryHookResult = ReturnType<typeof useCompanyChannelInfoByIdQuery>;
export type CompanyChannelInfoByIdLazyQueryHookResult = ReturnType<typeof useCompanyChannelInfoByIdLazyQuery>;
export type CompanyChannelInfoByIdSuspenseQueryHookResult = ReturnType<typeof useCompanyChannelInfoByIdSuspenseQuery>;
export type CompanyChannelInfoByIdQueryResult = Apollo.QueryResult<CompanyChannelInfoByIdQuery, CompanyChannelInfoByIdQueryVariables>;